'use strict';

angular.module('accessRequestModule')
    .directive('accessRequestPage', function () {
        return {
            restrict: 'E',
            controller: 'AccessRequestCtrl',
            controllerAs: '$ctrl',
            templateUrl: 'access.request/accessRequestPage.html',
        }
});
